import { buildFunctionUrl } from '../config/functions';

const jsonRequest = async (path, payload = {}) => {
  const response = await fetch(buildFunctionUrl(path), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || 'No pudimos comunicarnos con el servicio de checkout.');
  }

  return response.json();
};

export const createCheckoutIntent = async (payload = {}) => {
  return jsonRequest('/ecommerceCreatePaymentIntent', payload);
};

export const submitCheckoutOrder = async (payload = {}) => {
  return jsonRequest('/ecommerceFinalizeOrder', payload);
};

export const serializeCartForCheckout = (items = []) =>
  items.map((item) => ({
    productId: item.productId,
    name: item.name,
    basePrice: item.basePrice,
    variants: item.variants || [],
    addons: item.addons || [],
    totalPrice: item.totalPrice,
    quantity: item.quantity || 1,
  }));
